/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from 'react';
import { Form, FormProps } from 'react-final-form';
import { ModalFuncProps } from 'antd';
import ScModal from '../ScModal';
import {
    BUTTON_ACTION_TYPE,
    ButtonModalAction,
} from '@app/components/UI/Button';

// T đại diện cho kiểu dữ liệu của Form Values
interface CommonFormModalProps<T> extends FormProps<T> {
    open: boolean;
    title: string;
    onClose: () => void;
    width?: number;
    // Cho phép truyền thêm các props khác của Antd Modal nếu cần
    modalProps?: Partial<ModalFuncProps>;
    // Custom button render hoặc các cấu hình khác
    saveButtonLabel?: string;
    // Custom footer: nếu không truyền sẽ dùng mặc định (Lưu + Đóng)
    footer?:
        | React.ReactNode[]
        | ((formState: {
              handleSubmit: any;
              invalid: boolean;
              submitting: boolean;
          }) => React.ReactNode[]);
    children?: any;
}

export function ScModalFinalForm<T extends Record<string, any>>({
    open,
    title,
    onClose,
    onSubmit,
    initialValues,
    mutators,
    children,
    width = 700,
    footer,
    className,
    ...rest
}: CommonFormModalProps<T>) {
    const keyRef = useRef(0);
    const prevInitialRef = useRef(initialValues);

    if (prevInitialRef.current !== initialValues) {
        keyRef.current += 1;
        prevInitialRef.current = initialValues;
    }

    return (
        <Form
            key={keyRef.current}
            onSubmit={onSubmit}
            initialValues={initialValues}
            mutators={mutators}
            render={({ handleSubmit, invalid, submitting, form, values }) => {
                const resolvedFooter = footer
                    ? typeof footer === 'function'
                        ? footer({ handleSubmit, invalid, submitting })
                        : footer
                    : [
                          <div className="btn-group" key="btn-group">
                              <ButtonModalAction
                                  key="submit"
                                  type="primary"
                                  disabled={invalid || submitting}
                                  onClick={handleSubmit}
                                  buttonType={BUTTON_ACTION_TYPE.SAVE}
                                  buttonLabel="Lưu"
                                  isLeftIcon
                              />
                              <ButtonModalAction
                                  key="back"
                                  onClick={onClose}
                                  buttonLabel="Đóng"
                                  buttonType={BUTTON_ACTION_TYPE.CLOSE}
                              />
                          </div>,
                      ];

                return (
                    <ScModal
                        title={title}
                        open={open}
                        onCancel={onClose}
                        width={width}
                        className={className}
                        style={{ top: '20px' }}
                        footer={resolvedFooter}
                    >
                        {/* Truyền các form state xuống children nếu cần (Pattern: Render Props)
                        Hoặc chỉ đơn giản là children nếu bạn dùng Field bên trong
                    */}
                        <>
                            {typeof children === 'function'
                                ? children({
                                      form,
                                      values,
                                      invalid,
                                      submitting,
                                  })
                                : children}
                        </>
                    </ScModal>
                );
            }}
            {...rest}
        />
    );
}
